import {useQuery, UseQueryResult} from "react-query";
import {getAllModuleCarte} from "./moduleCarte.services";


export const useGetAllModuleCarte = (id:number):UseQueryResult<ModuleCarte[], Error>=>{
    return useQuery(["modules_carte", id], ()=>getAllModuleCarte(id), {
        enabled:id!==0
    })
}